import { applyMiddleware, compose, createStore } from 'redux';
import reducers from './store/reducers';
import thunk from 'redux-thunk';
var composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
var enhancer = composeEnhancers(applyMiddleware(thunk));
var store = createStore(reducers, enhancer);
export default store;



//////////////////
// WEBPACK FOOTER
// ./src/store.ts
// module id = 90
// module chunks = 81